import { CircularProgress, TextField } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { axiosClient } from "../../../config/axios";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../../components/Button";
import ButtonShared from "../../../components/Button/Button";
import Modal from "../../../components/Modal";
import Stepper from "../../../components/Stepper/Stepper";
import SellModal from "../../../containers/Sell/SellModalContainer";
import { images } from "../../../constants/images";
import { useToast } from "../../../helpers/hooks";
import { SellSearchProps } from "../../../interfaces/salePost";
import styles from "./search.module.scss";
import { capitalize } from "../../../helpers/app";
import SellSteps from './components/SellSteps';

const Search = ({
    user,
    initialFlow,
    getPlateInfo,
    plate,
    fetchingPlateRepeated,
    plateRepeatedStatus,
    cleanPlateRepeated,
    getIsPlateRepeated,
    fetchingPlateInfo,
    brand,
    year,
    clearSalePost,
    setPlate,
    setVin,
    documents,
    reSendValidation,
    reSendValidationFetching,
    cleanReSendValidation,
    isFoundPlate,
    getYears,
    years,
    vehicleData,
    cleanPlateInfo
}: SellSearchProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    const vinRef = useRef(null);
    const text1Ref = useRef(null);
    const text2Ref = useRef(null);
    const text3Ref = useRef(null);
    const [vin1, setVin1] = useState("");
    const [platePart1, setPlatePart1] = useState("");
    const [platePart2, setPlatePart2] = useState("");
    const [platePart3, setPlatePart3] = useState("");
    const [status, setStatus] = useState<any>("");
    const [openModalValidationMail, setOpenModalValidationMail] = useState<boolean>(false);
    const [openModalPlateSearch, setOpenModalPlateSearch] = useState<boolean>(false);
    const [timeOutMessage, setTimeOutMessage] = useState<any>({ open: false, text: "" });
    const [openModalInstructions, setOpenModalInstructions] = useState<boolean>(false);
    const [openModalDetails, setOpenModalDetails] = useState<boolean>(false);
    const [currentModalStep, setCurrentModalStep] = useState<number>(1);
    const [hasPublications, setHasPublications] = useState<boolean | null>(null);

    useEffect(() => {
        getYears()
    }, []);
    useEffect(() => {
        const checkUserPublications = async () => {
            if (!user) {
                setOpenModalInstructions(true);
                setHasPublications(false);
                return;
            }

            try {
                const response = await axiosClient.get('/publications/my-publications?limit=20&page=1');
                const { data } = response.data;
                setHasPublications(data.publications.length > 0);

                if (data.publications.length === 0) {
                    setOpenModalInstructions(true);
                }
            } catch (error) {
                console.error('Error al obtener publicaciones:', error);
            }
        };

        checkUserPublications();
    }, [user]);

    const onPressModalPlate = () => {
        cleanPlateRepeated();
        if (status === "success") {
            localStorage.removeItem("linzeFormData");
            navigate(`/sell/car_search_information`, { state: { type: 'used-car' } });
        } else {
            localStorage.removeItem("linzeFormData");
            navigate(`/sell/steps`, { state: { type: 'used-car' } });
        }
    }

    const onkeydown = (key: string, ref: any) => {
        if (ref?.current?.value.length === 0) {
            if (ref?.current?.name === "platePart1" && key.toLowerCase() === "arrowright") {
                nextRefFocus(0);
            }
            if (ref?.current?.name === "platePart2") {
                if (key.toLowerCase() === "arrowright") {
                    nextRefFocus(1);
                }
                if (key.toLowerCase() === "backspace" || key.toLowerCase() === "arrowleft") {
                    backRefFocus(0);
                }
            }
            if (ref?.current?.name === "platePart3" && (key.toLowerCase() === "backspace" || key.toLowerCase() === "arrowleft")) {
                backRefFocus(2);
            }
        } else {
            if (ref?.current?.name === "platePart3" && key.toLowerCase() === "enter") onPressNext();
        }
    }

    const changeRef = (text: string, type?: undefined | number) => {
        if (text.length === 2 && typeof type !== 'undefined') {
            nextRefFocus(type);
        }
        if (text.length === 0 && type) {
            backRefFocus(type);
        }
    }

    const handlePressValidationMail = () => {
        reSendValidation();
    }

    const nextRefFocus = (key: number) => {
        const refs: any = [
            text2Ref,
            text3Ref
        ]
        if (key === 2) {
            return;
        }
        refs[key].current.focus();
    };

    const backRefFocus = (key: number) => {
        const refs: any = [
            text1Ref,
            text1Ref,
            text2Ref,
        ]
        refs[key].current.focus();
    };

    const onPressNext = () => {
        setVin("");
        if (location.pathname.includes('used-car')) {
            initialFlow();
            if (!isPlateComplete) {
                toast("ingresa una patente valida");
                return;
            }
            const currentPlate = `${platePart1}${platePart2}${platePart3}`;
            getIsPlateRepeated(currentPlate.replaceAll(".", ""));
            setStatus("loading");
            setOpenModalPlateSearch(true);
            setTimeout(() => setTimeOutMessage({ open: true, text: "Espera un momento" }), 5000);
            setTimeout(() => setTimeOutMessage({ open: true, text: "Espera un momento..." }), 15000);
        }
    };

    const onPressNextNew = () => {
        localStorage.removeItem("linzeFormData");
        setVin(vin1.replaceAll(" ", ""));
        navigate(`/sell/steps`, { state: { type: 'new-car' } });
    };

    const isPlateComplete = useMemo(() => {
        if (location.pathname.includes('used-car')) {
            if (!platePart1 || !platePart2 || !platePart3 || platePart3.length < 2) {
                return false;
            }
            return true;
        }
        if (!vin1 || vin1.length < 17) {
            return false;
        }
        return true;
    }, [platePart1, platePart2, platePart3, vin1]);

    useEffect(() => {
        if (reSendValidationFetching === "failure") {
            toast("Ha ocurrido un error al enviar el email de verificación");
            setOpenModalValidationMail(false);
            cleanReSendValidation();
        }
        if (reSendValidationFetching === "success") {
            toast("Se te ha enviado un email de verificación");
            setOpenModalValidationMail(false);
            cleanReSendValidation();
        }
    }, [reSendValidationFetching]);

    useEffect(() => {

        if (plateRepeatedStatus === "isNotRepeated" && fetchingPlateRepeated === "success") {
            const currentPlate = `${platePart1}${platePart2}${platePart3}`;
            if (currentPlate.replaceAll(".", "") === "") {
                return toast("Debes ingresar una patente");
            }
            getPlateInfo(currentPlate.replaceAll(".", ""));
        }
        if (plateRepeatedStatus === "isRepeated" && fetchingPlateRepeated === "failure") {
            toast("Esta patente ya se encuentra publicada, por favor intente con otra");
            setOpenModalPlateSearch(false);
            setStatus("");
            clearSalePost();
        }
    }, [plateRepeatedStatus, fetchingPlateRepeated]);

    useEffect(() => {
        const maxAge = 100;
        const comparation = new Date().getFullYear() - maxAge;
        if (fetchingPlateInfo === "failure") {
            setStatus("failure");
            const currentPlate = `${platePart1}${platePart2}${platePart3}`;
            setPlate(currentPlate.replaceAll(".", ""));
            cleanPlateInfo();
        }
        if (fetchingPlateInfo === "success") {
            if (vehicleData?.year && vehicleData.year < comparation) {
                setOpenModalPlateSearch(false);
                setStatus("");
                toast(`Ups! No se puede publicar un auto con antigüedad mayor a ${maxAge} años`);
                cleanPlateInfo();
                return;
            }
            setStatus("success");
        }
    }, [fetchingPlateInfo]);
     
    useEffect(() => {
        if (plate && plate.length > 0) {
            setPlatePart1("");
            setPlatePart2("");
            setPlatePart3("");
        }
    }, []);


    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.pageTitle}>Vamos a publicar tu vehículo</h1>
            <div className={styles.searchContainer}>
                <div className={styles.leftContent}>
                    <h1 className={styles.mainTitle}>Vende Tu Auto 100% Online</h1>
                    <div className={styles.inputSection}>
                        <p className={styles.inputLabel}>
                            {location.pathname.includes('used-car') ? 'Ingresa tu patente' : 'Ingresa el número VIN'}
                        </p>
                        <div className={styles.inputsContainer}>
                            {location.pathname.includes('used-car') ? (
                                <>
                                    <TextField
                                        name='platePart1'
                                        id="platePart1"
                                        value={platePart1}
                                        inputRef={text1Ref}
                                        disabled={false}
                                        variant="standard"
                                        autoComplete="off"
                                        placeholder="NC"
                                        className={styles.textFieldInput}
                                        onChange={(e) => [setPlatePart1(e.target.value.toUpperCase()), changeRef(e.target.value, 0)]}
                                        InputProps={{ disableUnderline: true }}
                                        inputProps={{ maxLength: 2 }}
                                        onKeyDown={(ev: any) => onkeydown(ev.key, text1Ref)}
                                    />
                                    <TextField
                                        name='platePart2'
                                        id="platePart2"
                                        value={platePart2}
                                        inputRef={text2Ref}
                                        disabled={false}
                                        variant="standard"
                                        placeholder="SF"
                                        autoComplete="off"
                                        className={styles.textFieldInput}
                                        onChange={(e) => [setPlatePart2(e.target.value.toUpperCase()), changeRef(e.target.value, 1)]}
                                        InputProps={{ disableUnderline: true }}
                                        inputProps={{ maxLength: 2 }}
                                        onKeyDown={(ev: any) => onkeydown(ev.key, text2Ref)}
                                    />
                                    <TextField
                                        name='platePart3'
                                        id="platePart3"
                                        value={platePart3}
                                        inputRef={text3Ref}
                                        disabled={false}
                                        variant="standard"
                                        placeholder="78"
                                        autoComplete="off"
                                        className={styles.textFieldInput}
                                        onChange={(e) => [setPlatePart3(e.target.value.toUpperCase()), changeRef(e.target.value, 2)]}
                                        InputProps={{ disableUnderline: true }}
                                        inputProps={{ maxLength: 2 }}
                                        onKeyDown={(ev: any) => onkeydown(ev.key, text3Ref)}
                                    />
                                </>
                            ) : (
                                <TextField
                                    name='vin'
                                    id="vin"
                                    value={vin1}
                                    inputRef={vinRef}
                                    disabled={false}
                                    variant="standard"
                                    autoComplete="off"
                                    placeholder="Ingresa el número VIN"
                                    className={`${styles.textFieldInput} ${styles.vinInput}`}
                                    onChange={(e) => setVin1(e.target.value.toUpperCase())}
                                    InputProps={{ disableUnderline: true }}
                                    inputProps={{ maxLength: 17 }}
                                />

                            )}

                        </div>
                        {location.pathname.includes('new-car') && (
                            <div className={styles.vinCharCounter}>
                                Caracteres: {vin1.length}/17
                            </div>
                        )}
                    </div>
                    {location.pathname.includes('used-car') ? (
                        <Button
                            onPress={onPressNext}
                            title="Continuar"
                            primary
                            disabled={!isPlateComplete}
                            className={styles.button}
                        />
                    ) : (
                        <Button
                            onPress={onPressNextNew}
                            title="Continuar"
                            primary
                            disabled={!isPlateComplete}
                            className={styles.button}
                        />
                    )}
                </div>
                <div className={styles.rightContent}>
                    <img src={images.linzePatente} alt="Car example" className={styles.carImage} />
                </div>

                <Modal open={openModalPlateSearch} variant='white'>
                    <div className={styles.modalPlateSearch}>
                        {
                            status === "loading" &&
                            <div className={styles.loaderPlateSearch}>
                                <CircularProgress
                                    size={styles.loader}
                                    classes={{
                                        colorPrimary: styles.loader
                                    }}
                                />
                                <p>
                                    <span>Buscando información de tu vehiculo</span>
                                    <span className={`${styles.timeOut} ${timeOutMessage?.open && styles.show}`}>{timeOutMessage?.text}</span>
                                </p>
                            </div>
                        }
                        {
                            status === "failure" &&
                            <div className={styles.plateFailure}>
                                <img src={images.isoLogoTipo} alt="linze" className={styles.image} />
                                <p className={styles.title}>No encontramos información de tu vehiculo</p>
                                <p className={styles.subTitle}>A continuación podrás ingresarla manualmente</p>
                                <Button
                                    onPress={onPressModalPlate}
                                    title="Continuar"
                                    primary
                                    className={`${styles.button}`}
                                />
                            </div>
                        }
                        {
                            status === "success" &&
                            <div className={styles.plateSuccess}>
                                <img src={images.linzeRoundIsoLogo} alt="linze" className={styles.image} />
                                <p className={styles.subTitle}>Encontramos información de tu</p>
                                <p className={styles.carName}>{capitalize(brand?.label)}</p>
                                <Button
                                    onPress={onPressModalPlate}
                                    title="Continuar"
                                    primary
                                    className={styles.button}
                                />
                            </div>
                        }
                    </div>
                </Modal>
                <Modal open={openModalValidationMail}>
                    <div className={styles.modalContainerValidationMail}>
                        <p className={styles.message}>
                            <span className={styles.title}>¡Debes validar tu email!</span>
                            <span className={styles.description}>Para realizar esta acción es necesario que tu cuenta esté validada</span>
                        </p>
                        <ButtonShared
                            onPress={handlePressValidationMail}
                            title="Enviar email"
                            secondary
                            loading={reSendValidationFetching === "loading"}
                        />
                        <ButtonShared
                            onPress={() => setOpenModalValidationMail(false)}
                            title="Volver"
                            className={styles.buttonBack}
                        />
                    </div>
                </Modal>

            </div>

            <SellSteps />
        </div>
    )
};

export default Search;